{
  "CxiLicenceType_SOLO": "Solo",
  "CxiLicenceType_TEAMS": "Squadre",
  "CxiLicenceType_UNITE": "Unire",
  "CxiLicenceType_NONE": "Nessuno",
  "NAME": "CxiLicenceTypes"
}